import 'slick-carousel'
(function ($) {
	function initializeSlider( $block ) {
		const slickWrapper = $($block.find('.gallery-wrapper'));
		if (!slickWrapper.hasClass('slick-initialized')) {
			const prevArrow = $block.find('.gallery-nav--prev');
			const nextArrow = $block.find('.gallery-nav--next');
			slickWrapper.slick({
					slide: '.gallery-item',
					rows: 0,
					infinite: true,
					arrows: true,
					slidesToShow: 3,
					prevArrow: prevArrow,
					nextArrow: nextArrow,
					swipe: false,
					responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
								swipe: true
							}
						},
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 1,
								swipe: true
							}
						}
					]
				}
			);
		}
	}

	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=indy/gallery', initializeSlider );
	}

	$(document).ready(function () {
		// initialize gallery block slider
		$('.indy-block-gallery').each(function(){
			initializeSlider( $(this) );
		});

		// Event Single Page Slider
		const eventMedia = $('.indy-event__media');
		const slickWrapper = $('.indy-event__media__wrapper');
		if (eventMedia.length) {
			if (!slickWrapper.hasClass('slick-initialized')) {
				const prevArrow = eventMedia.find('.event-nav--prev');
				const nextArrow = eventMedia.find('.event-nav--next');
				slickWrapper.slick({
						slide: '.indy-event__media__item',
						rows: 0,
						infinite: true,
						arrows: true,
						slidesToShow: 3,
						prevArrow: prevArrow,
						nextArrow: nextArrow,
						swipe: false,
						responsive: [
							{
								breakpoint: 1200,
								settings: {
									slidesToShow: 2,
									swipe: true
								}
							},
							{
								breakpoint: 992,
								settings: {
									slidesToShow: 1,
									swipe: true
								}
							}
						]
					}
				);
			}
		}
	});

})(jQuery);

